:host {
  display: contents;
  --ch-window-mask-z-index: var(--ch-tabular-grid-settings-layer);
}
